export default {
  data() {
    return {
      isRead: false, 
    };
  },
  created() {
    this.initializeNotice();
  },
  methods: {
    initializeNotice() {
      const storedIsRead = localStorage.getItem('is_read');

      if (storedIsRead === null) {
        localStorage.setItem('is_read', JSON.stringify(this.isRead));
      } else {
        this.isRead = JSON.parse(storedIsRead);
      }
    },
    markAsRead() {
      this.isRead = true;
      localStorage.setItem('is_read', JSON.stringify(this.isRead));
    },
    resetReadStatus() {
      this.isRead = false;
      localStorage.setItem('is_read', JSON.stringify(this.isRead));
    },
  },
};


export function clearExceptIsRead(clear_all=false) {
  const isReadValue = localStorage.getItem('is_read');
  const shouldReload = parseInt(localStorage.getItem('should_reload'), 10) || 0;
  const ert_version = localStorage.getItem('ert_version');
  const access_token = localStorage.getItem('access_token');


  if (clear_all) {
    localStorage.clear();
    localStorage.setItem('is_read', isReadValue);
    if (shouldReload === 0) {
      localStorage.setItem('should_reload', 1);
      window.location.reload()
    } else {
      localStorage.setItem('should_reload', 0);
    }

  } else {
    if (isReadValue !== null) {
      localStorage.setItem('is_read', isReadValue);
    }
    
  }

  localStorage.setItem('ert_version', ert_version);
  localStorage.setItem('access_token', access_token);

}
